import { useEffect, useState } from 'react';

import styles from './RemotesList.module.scss';

export const parseFederationRemotes = () => {
    const remotes: Record<string, string> = {};
    __FEDERATION__.__INSTANCES__[0].options.remotes
        .sort((a, b) => a.name.localeCompare(b.name))
        .forEach((item) => {
            remotes[item.name] = item.entry;
        });
    return remotes;
};

export default function RemotesList({ serverRemotes }: { serverRemotes: Record<string, string> }) {
    const [clientRemotes, setClientRemotes] = useState<Record<string, string>>({});

    useEffect(() => {
        // This is to ensure that the client remotes are populated after the component mounts
        setClientRemotes(parseFederationRemotes());
    }, []);

    return (
        <>
            <div className={styles.dashboardRemotesList}>
                <div className={styles.remotesListCard}>
                    <h3>Server Side Remotes</h3>
                    <ul className={styles.remotesList}>
                        {Object.entries(serverRemotes).map(([name, remote]) => (
                            <li key={name}>
                                <span className={styles.remoteName}>{name}</span>
                                <a
                                    href={remote}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={styles.remoteLink}>
                                    {remote}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className={styles.remotesListCard}>
                    <h3>Client Side Remotes</h3>
                    <ul className={styles.remotesList}>
                        {Object.entries(clientRemotes).map(([name, remote]) => (
                            <li key={name}>
                                <span className={styles.remoteName}>{name}</span>
                                <a
                                    href={remote}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={styles.remoteLink}>
                                    {remote}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </>
    );
}
